/**
 * Plan purchase gate for shops (shop-status-fixes-nov2, review item H1).
 *
 * Only an APPROVED shop may buy or restore a Pro / Premium plan in the app.
 * Pending, rejected and suspended shops would be charged by the store for a
 * plan they cannot use (the backend refuses POST /billing/iap/sync with 403
 * and web Stripe checkout with 403). Non-shop accounts are not affected.
 *
 * Pure module (no imports) so it is cheap to unit test.
 */
export const PLANS_AFTER_APPROVAL_MESSAGE =
  "Plans are available after your shop is approved. You can subscribe as soon as an admin approves your application.";
export const PLANS_LOCKED_MESSAGE =
  "Plans are not available while your shop account is restricted. Contact support if you think this is a mistake.";
export const PLAN_LOCKED_BUTTON_LABEL = "Available after approval";

function level(user) {
  const s = String((user && (user.shop_access || user.status)) || "").toLowerCase();
  if (s === "approved" || s === "pending" || s === "rejected" || s === "suspended") return s;
  if (s === "deactivated" || s === "deleted") return "suspended";
  return "pending"; // unknown shop status fails closed, same as the backend
}

/** { allowed, level, message } for the signed-in user. */
export function shopPlanAccess(user) {
  if (!user) return { allowed: false, level: null, message: PLANS_AFTER_APPROVAL_MESSAGE };
  if (user.role !== "shop") return { allowed: true, level: null, message: null };
  const lv = level(user);
  const allowed = lv === "approved" && user.status === "approved" && user.can_purchase_plan !== false;
  if (allowed) return { allowed: true, level: lv, message: null };
  return {
    allowed: false,
    level: lv,
    message: lv === "rejected" || lv === "suspended" ? PLANS_LOCKED_MESSAGE : PLANS_AFTER_APPROVAL_MESSAGE,
  };
}

export function canPurchasePlan(user) {
  return shopPlanAccess(user).allowed;
}

/** Message for a refused POST /billing/iap/sync (403). */
export function syncRefusedMessage(detail) {
  const d = typeof detail === "string" ? detail.trim() : "";
  return d
    ? `Your purchase could not be activated: ${d}`
    : `Your purchase could not be activated. ${PLANS_AFTER_APPROVAL_MESSAGE}`;
}
